// extracted by mini-css-extract-plugin
export default {"container":"nav_folders-module__container--3QQa0"};